import gql from 'graphql-tag';

export const RIDES_BY_DRIVER_ID_QUERY = gql`
  query findRidesByDriverId($id: ID!) {
    findRidesByDriverId(id: $id) {
      id
      driver {
        id
        firstName
        lastName
        gender
        userImg
        userVehicles {
          make {
            name
          }
          model
          spec {
            engineSize
            fuelConsumption
          }
        }
      }
      seats
      startDate
      pricePerSeat
      startPoint {
        name
        location {
          lat
          lng
        }
        eta
      }
      endPoint {
        name
        location {
          lat
          lng
        }
        eta
      }
      waypoints {
        id
        name
      }
      waypointsEta {
        waypointId
        eta
      }
      createdAt
      updatedAt
    }
  }
`;
